/** Agent share modal types — matches BE CamelCase DTOs (`GET/POST /agents/{id}/share`). */

export type SharePermissionType = 'viewer' | 'editor';

export type ShareGrant = {
  permissionType: SharePermissionType;
  allowSubagents: boolean;
  allowSkills: boolean;
  allowTools: boolean;
  allowKb: boolean;
};

export type OrgShareGrant = {
  orgId: string;
  grant: ShareGrant;
};

export type ShareSubject = {
  userId?: string;
  role?: string;
};

export type ShareParticipant = {
  subject: ShareSubject;
  grant: ShareGrant;
  sharedAt?: string;
  sharedBy?: string;
};

export type MyShareAccess = {
  isOwner: boolean;
  permissionType?: SharePermissionType;
  canShare: boolean;
  canEditConfig: boolean;
  canManageSubagents: boolean;
  canManageSkills: boolean;
  canManageTools: boolean;
  canManageKb: boolean;
};

export type ShareParticipantInput = {
  userId: string;
  permissionType: SharePermissionType;
  allowSubagents?: boolean;
  allowSkills?: boolean;
  allowTools?: boolean;
  allowKb?: boolean;
};

export type OrgGrantInput = {
  orgId: string;
  permissionType: SharePermissionType;
  allowSubagents?: boolean;
  allowSkills?: boolean;
  allowTools?: boolean;
  allowKb?: boolean;
};

export type SaveShareRequest = {
  visibility?: 'public' | 'private';
  participants: ShareParticipantInput[];
  orgGrants: OrgGrantInput[];
};

export type ShareStateResponse = {
  isSuccess: boolean;
  visibility?: 'public' | 'private' | null;
  participants: ShareParticipant[];
  orgGrants: OrgShareGrant[];
  detail?: string;
};

export const DEFAULT_SHARE_GRANT = (): ShareGrant => ({
  permissionType: 'viewer',
  allowSubagents: false,
  allowSkills: false,
  allowTools: false,
  allowKb: false,
});
